import { Watches } from './Watches';

import './index.scss';

export const WatchBox = (props: any) => {
	return (
		<Watches {...props} />
	);
};
